import { transactionsSelectors, type transactionsTypes } from 'app-components/flux/transactions';
import { createAppSelector } from 'app-components/utils/core/reselect';
import { getBillableInvoiceSumForCustomerId, getBillableInvoiceSumForProjectId } from './billableInvoiceItemsSelectors';

export const getBillableInvoicePlusTxnsSumForProjectId = createAppSelector(
  [getBillableInvoiceSumForProjectId, transactionsSelectors.selectUnbilledProjectExpenses],
  (billableItemSum, transactions) => {
    const sum2 = transactions.reduce((acc: number, txn: transactionsTypes.TransactionItem) => acc + txn.item.amount, 0);
    return billableItemSum - sum2;
  },
);

export const getBillableItemPlusTxnsSumForCustomerId = createAppSelector(
  [getBillableInvoiceSumForCustomerId, transactionsSelectors.selectUnbilledCustomerExpenses],
  (billableItemSum, transactions) => {
    const sum2 = transactions.reduce((acc: number, txn: transactionsTypes.TransactionItem) => acc + txn.item.amount, 0);
    return billableItemSum - sum2;
  },
);
